

import React from 'react';
import { Input } from '@/components/ui/input';

interface DepartmentAutocompleteProps {
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const DepartmentAutocomplete = ({
  value,
  onValueChange,
  placeholder = "Enter department...",
  disabled = false,
}: DepartmentAutocompleteProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange?.(e.target.value);
  };

  return (
    <Input
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

